import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYuklemePlanAracAtama_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYuklemePlanAracAtama_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  ReadFromSessionStorage: string;
  ReadFromSessionStorage_dummy: string;
  Get_Helpers_UserInfoByUserName: any[];
  Get_Helpers_UserInfoByUserName_dummy: any[];
  YuklemePlan_Get_MasterById: any[];
  YuklemePlan_Get_MasterById_dummy: any[];
  YuklemePlan_AracAtama: number;
  YuklemePlan_AracAtama_dummy: number;
  Get_Firma_ParametreByName: any[];
  Get_Firma_ParametreByName_dummy: any[];
  GetMailBody_TedarikciYuklemePlanAracAtamaBildirim: string;
  GetMailBody_TedarikciYuklemePlanAracAtamaBildirim_dummy: string;
  SendMail: boolean;
  SendMail_dummy: boolean;
  Notify: boolean;
  Notify_dummy: boolean;
  GoBack: any;
  GoBack_dummy: any;
  isComp586230Enabled: "enabled" | "disabled";
  isComp241317Enabled: "enabled" | "disabled";
}

export class YuklemePlanAracAtama_ScreenBase extends React.PureComponent<
  IYuklemePlanAracAtama_ScreenProps,
  any
> {
  yuklemeplanaracatama_241317_value_kuikaDateRef: React.RefObject<any>;
  yuklemeplanaracatama_275391_value_kuikaDatetimeRef: React.RefObject<any>;
  ml = [
    {
      Id: "585b6303-ac4a-473f-8893-c915ede3bf84",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "2568180e-839c-476e-9ab5-e1aadacf8c90",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 553910, PropertyName: "value", Value: "Yükleme Plan Araç Atama" },
        { Id: 887086, PropertyName: "value", Value: "Yükleme No" },
        { Id: 94683, PropertyName: "value", Value: "Araç Tipi" },
        { Id: 586230, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 71255, PropertyName: "value", Value: "Planlanan Yükleme Tarihi" },
        { Id: 241317, PropertyName: "placeholder", Value: "Select Date..." },
        { Id: 655502, PropertyName: "value", Value: "Sürücü TC Kimlik No" },
        { Id: 59594, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 912904, PropertyName: "value", Value: "Sürücü Adı" },
        { Id: 515477, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 263250, PropertyName: "value", Value: "Sürücü Cep Telefonu" },
        { Id: 975101, PropertyName: "placeholder", Value: "905XX" },
        { Id: 25183, PropertyName: "value", Value: "Plaka" },
        { Id: 739452, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 653505, PropertyName: "value", Value: "Dorse Plaka" },
        { Id: 571924, PropertyName: "placeholder", Value: "Type here..." },
        {
          Id: 833559,
          PropertyName: "value",
          Value: "Tahmini Varış Tarih / Saat",
        },
        {
          Id: 275391,
          PropertyName: "placeholder",
          Value: "Select Date Time...",
        },
        { Id: 723285, PropertyName: "label", Value: "Yükleme Plan Ata" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.yuklemeplanaracatama_586230_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracatama_241317_value_kuikaDateRef = React.createRef();
    this.yuklemeplanaracatama_59594_value_kuikaTextInputRef = React.createRef();
    this.yuklemeplanaracatama_515477_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracatama_975101_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracatama_739452_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracatama_571924_value_kuikaTextInputRef =
      React.createRef();
    this.yuklemeplanaracatama_275391_value_kuikaDatetimeRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      ReadFromSessionStorage: "",
      Get_Helpers_UserInfoByUserName: [],
      YuklemePlan_Get_MasterById: [],
      YuklemePlan_AracAtama: 0,
      Get_Firma_ParametreByName: [],
      GetMailBody_TedarikciYuklemePlanAracAtamaBildirim: "",
      SendMail: false,
      Notify: false,
      GoBack: "",
      isComp586230Enabled: "disabled",
      isComp241317Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("yuklemeplanaracatama", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YuklemePlanAracAtamaPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("yuklemeplanaracatama", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("yuklemeplanaracatama", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YuklemePlanAracAtamaPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      yuklemeplanaracatama_586230_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.aracTipi ?? undefined,
      yuklemeplanaracatama_241317_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)
          ?.planlananYuklemeTarihi ?? undefined,
      yuklemeplanaracatama_59594_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.surucuTCKN ?? undefined,
      yuklemeplanaracatama_515477_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.surucuAdi ?? undefined,
      yuklemeplanaracatama_975101_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.surucuGSM ?? undefined,
      yuklemeplanaracatama_739452_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.plaka ?? undefined,
      yuklemeplanaracatama_571924_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.dorsePlaka ?? undefined,
      yuklemeplanaracatama_275391_value:
        this.state.YuklemePlan_Get_MasterById?.at?.(0)?.tahminiGelis ??
        undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YuklemePlanAracAtamaPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ReadFromSessionStorage =
      await ReactSystemFunctions.readFromSessionStorage(
        ReactSystemFunctions.convertToTypeByName("FirmaNo", "string")
      );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemePlanAracAtamaPageInit1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YuklemePlanAracAtamaPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UserName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      YuklemeId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanAracAtama/YuklemePlanAracAtamaPageInit1_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.Get_Helpers_UserInfoByUserName =
      result?.data.get_Helpers_UserInfoByUserName;
    stateVars.YuklemePlan_Get_MasterById =
      result?.data.yuklemePlan_Get_MasterById;
    formVars.yuklemeplanaracatama_586230_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].aracTipi
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].aracTipi
        : null
    );
    formVars.yuklemeplanaracatama_241317_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
        : null
    );
    formVars.yuklemeplanaracatama_59594_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].surucuTCKN
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].surucuTCKN
        : null
    );
    formVars.yuklemeplanaracatama_515477_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].surucuAdi
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].surucuAdi
        : null
    );
    formVars.yuklemeplanaracatama_975101_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].surucuGSM
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].surucuGSM
        : null
    );
    formVars.yuklemeplanaracatama_739452_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].plaka
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].plaka
        : null
    );
    formVars.yuklemeplanaracatama_571924_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].dorsePlaka
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].dorsePlaka
        : null
    );
    formVars.yuklemeplanaracatama_275391_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].tahminiGelis
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].tahminiGelis
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YuklemePlanAracAtamaPageInit2_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanAracAtamaPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.yuklemeplanaracatama_586230_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].aracTipi
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].aracTipi
        : null
    );

    formVars.yuklemeplanaracatama_241317_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].planlananYuklemeTarihi
        : null
    );

    formVars.yuklemeplanaracatama_59594_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].surucuTCKN
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].surucuTCKN
        : null
    );

    formVars.yuklemeplanaracatama_515477_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].surucuAdi
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].surucuAdi
        : null
    );

    formVars.yuklemeplanaracatama_975101_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].surucuGSM
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].surucuGSM
        : null
    );

    formVars.yuklemeplanaracatama_739452_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].plaka
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].plaka
        : null
    );

    formVars.yuklemeplanaracatama_571924_value = ReactSystemFunctions.toString(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].dorsePlaka
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].dorsePlaka
        : null
    );

    formVars.yuklemeplanaracatama_275391_value = ReactSystemFunctions.value(
      this,
      stateVars.YuklemePlan_Get_MasterById !== undefined
        ? stateVars.YuklemePlan_Get_MasterById?.length > 0
          ? stateVars.YuklemePlan_Get_MasterById[0].tahminiGelis
          : null
        : this.state.YuklemePlan_Get_MasterById?.length > 0
        ? this.state.YuklemePlan_Get_MasterById[0].tahminiGelis
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YuklemePlanAracAtamaComponent_723285_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "yuklemeplanaracatama_515477_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Sürücü Ad soyad bilgisi zorunludur",
      formName: "yuklemeplanaracatama_515477_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "yuklemeplanaracatama_975101_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Sürücü telefon numarası zorunludur",
      formName: "yuklemeplanaracatama_975101_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.startsWith(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracatama_975101_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("90", "string")
      ),
      message: "Cep telefon numarası ülke kodu (90) ile başlamalı",
      formName: "yuklemeplanaracatama_975101_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isEqualLength(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracatama_975101_value",
            "value",
            "",
            "",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("12", "string")
      ),
      message: "Cep telefonu numarası 12 karakter olmalıdır !",
      formName: "yuklemeplanaracatama_975101_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "yuklemeplanaracatama_739452_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Plaka bilgisi zorunludur",
      formName: "yuklemeplanaracatama_739452_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "yuklemeplanaracatama_571924_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Dorse Plaka Zorunludur",
      formName: "yuklemeplanaracatama_571924_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "yuklemeplanaracatama_275391_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "Tahmini geliş tarih-saaat bilgisi zorunludur",
      formName: "yuklemeplanaracatama_275391_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "yuklemeplanaracatama_59594_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "TC Kimlik No zorunludur",
      formName: "yuklemeplanaracatama_59594_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      SurucuAdi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracatama_515477_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Gsm_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracatama_975101_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Plaka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracatama_739452_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      DorsePlaka_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracatama_571924_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      UserId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].id
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].id
            : null
        ),
        "Guid"
      ),
      TahminiGelis_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracatama_275391_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "Date"
      ),
      TCKN_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracatama_59594_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.YuklemeId ?? this.props.screenInputs.yuklemeid,
        "Guid"
      ),
      FirmaNo_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(this, this.state.ReadFromSessionStorage),
        "number"
      ),
      ParametreAdi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "TedarikciAtamaMailTo",
          "string"
        ),
        "string"
      ),
      YuklemeNo_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.YuklemePlan_Get_MasterById !== undefined
            ? stateVars.YuklemePlan_Get_MasterById?.length > 0
              ? stateVars.YuklemePlan_Get_MasterById[0].yuklemeNo
              : null
            : this.state.YuklemePlan_Get_MasterById?.length > 0
            ? this.state.YuklemePlan_Get_MasterById[0].yuklemeNo
            : null
        ),
        "string"
      ),
      Plaka_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracatama_739452_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SurucuAdi_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracatama_515477_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      SurucuTCKN_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yuklemeplanaracatama_59594_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      TedarikciAdi_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Helpers_UserInfoByUserName !== undefined
            ? stateVars.Get_Helpers_UserInfoByUserName?.length > 0
              ? stateVars.Get_Helpers_UserInfoByUserName[0].bagliFirmaAdi
              : null
            : this.state.Get_Helpers_UserInfoByUserName?.length > 0
            ? this.state.Get_Helpers_UserInfoByUserName[0].bagliFirmaAdi
            : null
        ),
        "string"
      ),
      templateId_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      receivers_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.Get_Firma_ParametreByName !== undefined
            ? stateVars.Get_Firma_ParametreByName?.length > 0
              ? stateVars.Get_Firma_ParametreByName[0].parametreDegeri
              : null
            : this.state.Get_Firma_ParametreByName?.length > 0
            ? this.state.Get_Firma_ParametreByName[0].parametreDegeri
            : null
        ),
        "string"
      ),
      subject_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName(
          "Yükleme Planı Tedarikçi İşlem Bildirimi",
          "string"
        ),
        "string"
      ),
      sender_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      cc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      bcc_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      language_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      body_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          stateVars.GetMailBody_TedarikciYuklemePlanAracAtamaBildirim
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YuklemePlanAracAtama/YuklemePlanAracAtamaComponent_723285_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YuklemePlan_AracAtama = result?.data.yuklemePlan_AracAtama;
    stateVars.Get_Firma_ParametreByName =
      result?.data.get_Firma_ParametreByName;
    stateVars.GetMailBody_TedarikciYuklemePlanAracAtamaBildirim =
      result?.data.getMailBody_TedarikciYuklemePlanAracAtamaBildirim;
    stateVars.SendMail = result?.data.sendMail;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YuklemePlanAracAtamaComponent_723285_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YuklemePlanAracAtamaComponent_723285_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "04491ad1_79b3_e9f7_80ae_f90fb0efd370_notify",
        this.defaultML,
        "Yükleme Planı Sürücüye Atandı"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("center", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );
    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YuklemePlanAracAtamaPageInit();
    }
  }
}
